<template>
  <div
    class="form_item"
    :class="save_to + '_wrapper'"
    style="position: relative"
  >
    <Label :required="required" :label="label" :name="name" />
    <Multiselect
      :options="filteredOptionsList"
      label="name"
      :multiple="multiple"
      v-model="selected"
      :searchable="searchable"
      :closeOnSelect="closeOnSelect"
      :showNoOptions="false"
      :placeholder="placeholder"
      :limit="limit > 1 ? limit : undefined"
      @input="handleValueChange"
      :showLabels="false"
      :options-limit="100000"
      :loading="isLoading"
      :clear-on-select="true"
      @search-change="asyncFind"
      :track-by="multiple ? 'value' : undefined"
    >
      <template slot="noOptions">{{
        configuration.messageListEmpty || $t("multiselect_list_empty", locale)
      }}</template>
      <template slot="noResult">...</template>
      <template slot="singleLabel" slot-scope="props">
        <span class="option__desc">
          <span class="option__title">{{ props.option.name }}</span>
        </span>
      </template>

      <template slot="option" slot-scope="props">
        <div class="option__desc">
          <div class="option__title">{{ props.option.name }}</div>
        </div>
      </template>
    </Multiselect>
    <input
      type="text"
      :name="`${validationLabel || label}_hidden_required`"
      class="multiselect_hidden"
      v-model="selected"
      style="
        width: 1px;
        height: 1px;
        position: absolute;
        bottom: 10px;
        left: 10px;
        z-index: 0;
        border: none;
        background-color: transparent;
      "
      :required="required"
      :v-validate="rules"
    />
    <p v-if="info !== undefined" class="info" v-html="info"></p>
    <span
      class="error"
      v-show="errors.has(`${validationLabel || label}_hidden_required`)"
      v-text="errors.first(`${validationLabel || label}_hidden_required`)"
    ></span>
  </div>
</template>

<script>
// TODO replace vue-select by vue-multiselect
import { validatorComponent } from "./validatorComponentMixin";
import i18n from "./i18n";
import Multiselect from "vue-multiselect";
import axios from "axios";
import { debounce } from "lodash";

import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  name: "selectMultiple",
  components: {
    Multiselect,
  },
  mixins: [validatorComponent, i18n.mixin],
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
    },
    save_to: String,
    configuration: {
      type: Object,
      default() {
        return {};
      },
    },
    placeholder: {
      type: String,
      default: "",
    },
    info: String,
    validationLabel: String,
    name: String,
    searchable: Boolean,
    ajax: Boolean,
    ajaxUrl: String,
    closeOnSelect: Boolean,
    unique: Boolean,
    operationId: String,
    multiple: Boolean,
    limit: Number,
    nbMaxSelected: {
      type: Number,
      default: 0,
    },
  },
  data: function () {
    return {
      selected: undefined,
      isLoading: false,
      isDownloaded: false,
      ajaxOptions: [],
    };
  },
  created() {
    this.asyncFind = debounce(this.asyncFind.bind(this), 300);
  },
  computed: {
    optionsList() {
      if (this.ajax && this.ajaxUrl && this.ajaxUrl.indexOf("http") > -1) {
        return this.ajaxOptions;
      } else {
        return this.options;
      }
    },
    rules() {
      let unique = false;
      if (this.unique) {
        unique = [this.save_to, this.operationId];
      }
      return {
        required: this.required,
        unique,
      };
    },
    isMaxSelected() {
      return (
        this.nbMaxSelected > 0 &&
        this.selected &&
        this.selected.length >= this.nbMaxSelected
      );
    },
    filteredOptionsList() {
      if (this.isMaxSelected) {
        // Si la limite est atteinte, on ne montre que les options déjà sélectionnées
        return this.selected || [];
      }
      return this.optionsList;
    },
  },
  methods: {
    asyncFind(query) {
      if (query === "" && !this.isDownloaded) {
        this.ajaxOptions = [];
      }
      if (this.isLoading) {
        return;
      }
      if (
        this.ajax &&
        this.ajaxUrl &&
        this.ajaxUrl.includes("data-list/json/")
      ) {
        this.isLoading = true;
        axios.get(this.ajaxUrl + "?search=" + query).then((response) => {
          this.ajaxOptions = response.data;
          this.isLoading = false;
        });
        return;
      }
      if (this.isDownloaded) {
        return;
      }
      if (this.ajax && this.ajaxUrl && this.ajaxUrl.indexOf("http") > -1) {
        this.isLoading = true;
        axios.get(this.ajaxUrl).then((response) => {
          this.ajaxOptions = response.data;
          this.isLoading = false;
          this.isDownloaded = true;
        });
      }
    },
    handleValueChange(val) {
      // const value = val ? val[VALUE_COL_NAME] : null
      // this.selected = val
      if (this.multiple) {
        // Si on a une limite et qu'on essaie d'ajouter plus d'éléments que permis
        if (this.nbMaxSelected > 0 && val && val.length > this.nbMaxSelected) {
          // On garde seulement les premiers éléments jusqu'à la limite
          const limitedVal = val.slice(0, this.nbMaxSelected);
          this.selected = limitedVal;
          this.$emit("input", limitedVal.map((v) => v.value).join(":"));
        } else {
          // Pas de limite ou nombre d'éléments dans les limites
          this.$emit("input", val ? val.map((v) => v.value).join(":") : "");
        }
      } else {
        if (val) {
          this.$emit("input", val.value);
        } else {
          this.$emit("input", "");
        }
      }
    },
  },
};
</script>
<style>
.option__small {
  font-size: 0.8em;
}
</style>
